export const TAG_TYPES = {
    LEARNER: 'learner',
    BROADCAST: 'broadcast',
    TRAINING: 'training',
}